module.exports = __webpack_public_path__ + "static/media/buffet18.7cd6dd5e.jpg";